import React from 'react';
import { Seance } from './Seance';
import { CJEvent } from '@teetsh/app/src/types/event';
import tw from 'twin.macro';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';

interface Props {
  listOfEvents: CJEvent[][];
  classroomsOrg: ClassroomsOrg;
  collapsed: boolean;
}

export function Lines(props: Props) {
  const { listOfEvents, classroomsOrg, collapsed } = props;

  return (
    <div tw="flex pb-2 gap-2">
      {listOfEvents.map((events, index) => (
        <div key={index} tw="w-full">
          {events.map((event, j) => (
            <div key={event.id}>
              <Seance
                collapsed={collapsed}
                classroomsOrg={classroomsOrg}
                css={[events.length > 1 && j !== events.length - 1 && tw`pb-2`]}
                event={{ ...event, order: index }}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
